import { CARRIER_COORDINATION as T } from "@/constants/testIds";
import {
  Mail, Inbox, CalendarClock, AlertCircle, Repeat, FileSpreadsheet, EyeOff,
} from "lucide-react";

const problems = [
  { icon: Mail, title: "Multiple carrier conversations", detail: "Threads scattered across inboxes, chats and calls." },
  { icon: Inbox, title: "Booking confirmations across emails", detail: "Confirmations buried in reply chains and attachments." },
  { icon: CalendarClock, title: "Schedule changes", detail: "Vessel rollovers and cutoffs slip through without alerts." },
  { icon: AlertCircle, title: "Missing shipment updates", detail: "No single source of truth for container status." },
  { icon: Repeat, title: "Manual follow-ups", detail: "Ops teams chase carriers repeatedly for the same details." },
  { icon: FileSpreadsheet, title: "Spreadsheet tracking", detail: "Fragile trackers that break with every new shipment." },
  { icon: EyeOff, title: "Lack of centralized visibility", detail: "No unified view of bookings, containers and ETAs." },
];

export default function ProblemSection() {
  return (
    <section
      id="problem"
      data-testid={T.problem}
      className="relative border-t border-slate-line bg-white py-24"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="mx-auto max-w-3xl">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-blue-brand">The Problem</p>
          <h2 className="mt-4 text-3xl font-semibold text-navy sm:text-4xl lg:text-[44px] lg:leading-[1.08]">
            Carrier Coordination Shouldn&rsquo;t
            <br className="hidden sm:block" /> Depend On Emails.
          </h2>
          <p className="mt-5 max-w-2xl text-[15px] leading-relaxed text-slate-600 sm:text-base">
            Freight coordination breaks down when critical operational data lives across inboxes and spreadsheets. Every disconnected touchpoint adds risk, delay and cost across export logistics coordination.
          </p>
        </div>

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {problems.map(({ icon: Icon, title, detail }, i) => (
            <div
              key={title}
              className={`animate-fade-up group rounded-2xl border border-slate-line bg-white p-6 transition hover:border-slate-300 hover:shadow-card stagger-${(i % 6) + 1}`}
            >
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-slate-50 text-slate-500 transition group-hover:bg-blue-soft group-hover:text-blue-brand">
                <Icon className="h-5 w-5" strokeWidth={1.8} />
              </div>
              <h3 className="mt-4 text-[15px] font-semibold text-navy">{title}</h3>
              <p className="mt-2 text-[13.5px] leading-relaxed text-slate-500">{detail}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
